/* ═══════════════════════════════════════════
   SMART FOR LIFE — THEME JS
   ═══════════════════════════════════════════ */

(function () {
  'use strict';

  var money_format = '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return '$' + value;
  }

  // ── CART STATE ──
  var cartDrawerOpen = false;

  // ── OPEN / CLOSE DRAWER ──
  window.openCartDrawer = function () {
    var drawer  = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartOverlay');
    if (!drawer) return;
    refreshCartDrawer();
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.classList.add('drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    cartDrawerOpen = true;
  };

  window.closeCartDrawer = function () {
    var drawer  = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartOverlay');
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.classList.remove('drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    cartDrawerOpen = false;
  };

  // ── REFRESH CART DRAWER CONTENT ──
  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateAllCartCounts(cart.item_count);
      });
  }

  function renderCartDrawer(cart) {
    var body   = document.getElementById('cartDrawerBody');
    var footer = document.getElementById('cartDrawerFooter');
    var count  = document.getElementById('drawerCount');
    if (!body || !footer) return;

    if (count) count.textContent = cart.item_count;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer-empty"><div style="font-size:56px;margin-bottom:16px;">🛒</div><p>Your cart is empty.</p><a href="/collections/all-products" class="btn-primary" onclick="closeCartDrawer()" style="display:inline-block;margin-top:16px;">Shop Now →</a></div>';
      footer.innerHTML = '';
      return;
    }

    var itemsHtml = '';
    cart.items.forEach(function (item) {
      itemsHtml += '<div class="cdi" data-key="' + item.key + '">' +
        '<img src="' + item.image + '" alt="' + item.title + '" class="cdi-img">' +
        '<div class="cdi-info">' +
          '<div class="cdi-name">' + item.product_title + '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cdi-variant">' + item.variant_title + '</div>' : '') +
          '<div class="cdi-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="cdi-qty-wrap">' +
            '<button class="cdi-qty-btn" onclick="changeDrawerQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>' +
            '<span class="cdi-qty">' + item.quantity + '</span>' +
            '<button class="cdi-qty-btn" onclick="changeDrawerQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="cdi-remove" onclick="changeDrawerQty(\'' + item.key + '\',0)" aria-label="Remove">' +
          '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
      '</div>';
    });
    body.innerHTML = itemsHtml;

    footer.innerHTML =
      '<div class="cart-drawer-subtotal">' +
        '<span>Subtotal</span>' +
        '<span>' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      (cart.total_price < 10000 ? '<p class="cart-drawer-shipping-note">Add <strong>' + formatMoney(10000 - cart.total_price) + '</strong> more for free shipping!</p>' : '<p class="cart-drawer-shipping-note cart-drawer-shipping-free">🚚 You qualify for free shipping!</p>') +
      '<a href="/checkout" class="btn-primary cart-drawer-checkout">Checkout — ' + formatMoney(cart.total_price) + '</a>' +
      '<a href="/cart" class="cart-drawer-view-cart" onclick="closeCartDrawer()">View full cart</a>';
  }

  // ── CHANGE QUANTITY FROM DRAWER ──
  window.changeDrawerQty = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateAllCartCounts(cart.item_count);
      });
  };

  // ── UPDATE ALL CART COUNT BADGES ──
  function updateAllCartCounts(count) {
    document.querySelectorAll('#cartCount, #floatingCartCount').forEach(function (el) {
      el.textContent = count;
    });
    // Show/hide floating button
    var floatingBtn = document.getElementById('floatingCartBtn');
    if (floatingBtn) {
      floatingBtn.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  // ── AJAX ADD TO CART ──
  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || !form.action.includes('/cart/add')) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) {
            if (btn) btn.textContent = data.description || 'Error';
            return;
          }
          // Flash button green
          if (btn) {
            btn.style.background = '#27ae60';
            btn.textContent = '✓ Added!';
            setTimeout(function () {
              btn.style.background = '';
              btn.textContent = originalText;
            }, 2000);
          }
          // Open cart drawer
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              renderCartDrawer(cart);
              updateAllCartCounts(cart.item_count);
              openCartDrawer();
            });
        })
        .catch(function () { form.submit(); });
    });

    // Close drawer on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawerOpen) closeCartDrawer();
    });
  }

  // ── INIT FLOATING BUTTON VISIBILITY ON LOAD ──
  function initFloatingCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateAllCartCounts(cart.item_count);
      });
  }

  // ── COUNTDOWN TIMER ──
  function initTimer() {
    var hEl = document.getElementById('timerH');
    var mEl = document.getElementById('timerM');
    var sEl = document.getElementById('timerS');
    var stickyEl = document.getElementById('stickyTimerDisplay');
    if (!hEl && !stickyEl) return;

    var hours = window.__timerHours || 4;
    var mins  = window.__timerMins  || 17;
    var total = hours * 3600 + mins * 60;
    var stored = sessionStorage.getItem('sfl_timer_end');
    var endTime;
    if (stored) {
      endTime = parseInt(stored, 10);
    } else {
      endTime = Date.now() + total * 1000;
      sessionStorage.setItem('sfl_timer_end', endTime);
    }

    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      var str = pad(h) + ':' + pad(m) + ':' + pad(s);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
      if (stickyEl) stickyEl.textContent = str;
      if (remaining <= 0) sessionStorage.removeItem('sfl_timer_end');
    }
    tick();
    setInterval(tick, 1000);
  }

  // ── STICKY ATC BAR ──
  function initStickyATC() {
    var bar = document.getElementById('stickyAtc');
    if (!bar) return;
    var heroCard = document.querySelector('.hero-product-card') || document.querySelector('.hero-section');
    if (heroCard) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(heroCard);
    } else {
      window.addEventListener('scroll', function () {
        bar.classList.toggle('visible', window.scrollY > 400);
      }, { passive: true });
    }
  }

  // ── SCROLL ANIMATIONS ──
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;
    var animEls = document.querySelectorAll('.step, .benefit-card, .review-card, .product-card, .cs-card');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, i * 60);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    animEls.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

  // ── HEADER CART BUTTON → open drawer ──
  function initHeaderCartBtn() {
    var cartBtn = document.getElementById('cartBtn');
    if (cartBtn) {
      cartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    }
  }

  // ── INIT ──
  document.addEventListener('DOMContentLoaded', function () {
    initTimer();
    initStickyATC();
    initAjaxCart();
    initScrollAnimations();
    initFloatingCart();
    initHeaderCartBtn();
  });

})();
